import {ApolloProvider} from '@apollo/client';
import React from 'react';
import {createRoot} from 'react-dom/client';
import 'semantic-ui-css/semantic.min.css';
import {
    escape as _escape,
} from 'lodash';
import {Provider} from 'react-redux';

import * as actions from '@actions';
import HelperSession from '@utils/HelperSession';
import {setInfoBoxError} from '@reducers/InfoBoxes';
import MuiProvider from '@core/MuiProvider';

import App from './App';
import configuredStore from './store';
import apolloClient from './apolloClient';

import './scss/style.css';
import '@utils/prototypes';

configuredStore.dispatch(actions.validateAuthentication());

let prevError = null;

window.addEventListener('error', function(event) {
    const currentError = event.filename + event.colno + event.lineno;

    if (prevError !== currentError) {
        actions.reportError({
            url: window.location.href,
            previousRoute: configuredStore.getState().app.route.previousRoute,
            error: `<br/>
             * error: <br/>
             ${event.error.message} \n ${event.error.stack}<br/><br/>
             * element: ${_escape(JSON.stringify(event.currentTarget.document.activeElement.outerHTML).replace())}`,
            user: configuredStore.getState().app.security.user,
            timezone: configuredStore.getState().timezone,
        });

        setInfoBoxError({
            content: 'There was an error in action. Log has been sent.',
        });
    }

    prevError = currentError;
});

createRoot(document.getElementById('root')).render(
    <MuiProvider>
        <ApolloProvider client={apolloClient}>
            <Provider store={configuredStore}>
                <App />
            </Provider>
        </ApolloProvider>
    </MuiProvider>
);

const helperSession = new HelperSession();

if ('development' !== process.env.NODE_ENV) {
    helperSession.startListener();
}
